"use strict";

var sanitizeMongoKeys = require("../utils/sanitizeMongoKeys");

module.exports = [
  "$scope",
  "$state",
  "dialog",
  "Integration",
  "$translate",
  "integrations",
  "clients",
  "Authentication",
  "departments",
  "$uibModal",
  "toast",
  "gridConfiguration",
  "$compile",
  "members",
  "associatedFormsModal",
  "$sce",
  function (
    $scope,
    $state,
    dialog,
    Integration,
    $translate,
    integrations,
    clients,
    Authentication,
    departments,
    $uibModal,
    toast,
    gridConfiguration,
    $compile,
    members,
    associatedFormsModal,
    $sce
  ) {
    var _this = this;
    
    _this.showInfoText = false;

    const usersById = {};
    (members || []).forEach((member) => {
      usersById[String(member.id)] = member;
    });

    const getUserDisplayById = (userId) => {
      if (!userId) return "";
      const user = usersById[String(userId)];
      if (!user) return "";
      const fullName = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
      if (fullName && user.email) {
        return fullName + " <" + user.email + ">";
      }
      return fullName || user.email || "";
    };

    const userDisplayRenderer = (params) => {
      const eDiv = document.createElement("div");
      eDiv.textContent = params.value || "";
      return eDiv;
    };

    const getValidDateValue = (rawDate) => {
      if (rawDate === undefined || rawDate === null || rawDate === "") {
        return;
      }
      const date = new Date(rawDate);
      if (isNaN(date.getTime())) {
        return;
      }
      return date;
    };

    const auditTimestampRenderer = (params) => {
      if (!params.value) {
        return "";
      }
      const date = params.value instanceof Date ? params.value : new Date(params.value);
      if (isNaN(date.getTime())) {
        return "";
      }
      return date.getYYYYMMddHHmmss();
    };

    this.toggleInfoText = function () {
      _this.showInfoText = !_this.showInfoText;
    };

    this.connectionTypeTranslationMap = {
      form: "DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.FORM",
      voolks_sheet: "DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.VOOLKS_SHEET",
      s3: "DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.S3",
      google: "DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.GOOGLE",
      standard: "DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.STANDARD",
      ai: "DASHBOARD.DASH_INTEG.FIELDS.URL_TYPE.AI",
    };

    this.getIntegrationTypeLabel = (type) => {
      if (type === "getData") {
        return $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.TYPE_GET");
      }
      if (type === "validate") {
        return $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.TYPE_VALIDATE");
      }
      if (type === "populate") {
        return $translate.instant("DASHBOARD.DASH_INTEG.FIELDS.TYPE_AUTO");
      }
      return "";
    }

    this.getConnectionTypeLabel = (urlType) => {
      const normalizedUrlType = urlType || "standard";
      const translationKey = _this.connectionTypeTranslationMap[normalizedUrlType];
      return translationKey ? $translate.instant(translationKey) : urlType;
    }

    this.integrations = integrations.filter((_int) => {
      if (clients==null) return true;
      if (Authentication.isAuthorized(["admin"])) return true;
      if (_int.departmentId == undefined && _int.clientId == undefined) {
        _int.readOnly = true;
        return true;
      }
      
      if (_int.departmentId && departments.find((dept) => dept.id == _int.departmentId))
        return true;
      if (_int.clientId && clients.find((client) => client.id == _int.clientId))
        return true;
      if (_int.clientId && departments.find((dept) => dept.clientId == _int.clientId)){
        _int.readOnly = true;
        return true;
      }
      return false;
    });
    this.integrations.sort((A,B)=>
         (A.readOnly?"1":"0").concat(A.name).localeCompare((B.readOnly?"1":"0").concat(B.name))
    );
    _this.columnDefs = [
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.NAME"),
        field: "name",
        pinned: "left",
        minWidth: 350,
        cellRenderer: function (params) {
          if (params.data == undefined || params.data.id == undefined) return;
          var toReturn = [];
          var eDiv = document.createElement("div");
          toReturn.push(
            '<a href ui-sref="dashboard.integrations.integration({integrationId: \'' +
              params.data.id +
              "'})\">" +
              params.data.name +
              "</a>"
          );
          eDiv.innerHTML = toReturn.join("");
          return eDiv;
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.DESCRIP"),
        field: "description",
        minWidth: 240,
        cellClass: "my-center-aligned-cell",
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.SITE"),
        field: "clientId",
        minWidth: 180,
        cellClass: "my-center-aligned-cell",
        valueGetter: function (params) {
          if (params.data.client && params.data.client.name) {
            return params.data.client.name;
          }
          if (!params.data.clientId) {
            return $translate.instant("DASHBOARD.DASH_INTEG.GLOBAL");
          }
          var client = clients && clients.find(function (currentClient) {
            return currentClient.id === params.data.clientId;
          });
          return client ? client.name : "";
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.DEPT"),
        field: "departmentId",
        minWidth: 180,
        cellClass: "my-center-aligned-cell",
        valueGetter: function (params) {
          if (params.data.department && params.data.department.name) {
            return params.data.department.name;
          }
          if (!params.data.departmentId) {
            return $translate.instant("DASHBOARD.DASH_INTEG.GLOBAL");
          }
          var department = departments && departments.find(function (currentDepartment) {
            return currentDepartment.id === params.data.departmentId;
          });
          return department ? department.name : "";
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.TYPE"),
        field: "type",
        minWidth: 160,
        cellClass: "my-center-aligned-cell",
        valueGetter: function (params) {
          return _this.getIntegrationTypeLabel(params.data.type);
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.CONNECTION_TYPE"),
        field: "configuration.connection.urlType",
        minWidth: 180,
        cellClass: "my-center-aligned-cell",
        valueGetter: function (params) {
          var urlType =
            params.data &&
            params.data.configuration &&
            params.data.configuration.connection &&
            params.data.configuration.connection.urlType;
          return _this.getConnectionTypeLabel(urlType);
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.OFFLINE"),
        field: "configuration.connection.allowOffline",
        minWidth: 90,
        cellClass: "my-center-aligned-cell",
        valueGetter: function (params) {
          var allowOffline =
            params.data &&
            params.data.configuration &&
            params.data.configuration.connection &&
            params.data.configuration.connection.allowOffline;
          return allowOffline === true ? "Si" : "No";
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.CREATED_BY"),
        field: "createdBy",
        minWidth: 240,
        cellClass: "my-center-aligned-cell",
        cellRenderer: userDisplayRenderer,
        valueGetter: function (params) {
          return getUserDisplayById(params.data && params.data.createdBy);
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.CREATED_AT"),
        field: "_createdAt",
        minWidth: 150,
        cellClass: "my-center-aligned-cell",
        cellRenderer: auditTimestampRenderer,
        valueGetter: function (params) {
          return getValidDateValue(params.data && params.data._createdAt);
        },
        filter: gridConfiguration.dateFilter,
        comparator: gridConfiguration.dateComparator,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.UPDATED_BY"),
        field: "updatedBy",
        minWidth: 240,
        cellClass: "my-center-aligned-cell",
        cellRenderer: userDisplayRenderer,
        valueGetter: function (params) {
          return getUserDisplayById(params.data && params.data.updatedBy);
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_INTEG.COLS.UPDATED_AT"),
        field: "_updatedAt",
        minWidth: 150,
        cellClass: "my-center-aligned-cell",
        cellRenderer: auditTimestampRenderer,
        valueGetter: function (params) {
          return getValidDateValue(params.data && params.data._updatedAt);
        },
        filter: gridConfiguration.dateFilter,
        comparator: gridConfiguration.dateComparator,
      },
      {
        headerName: "",
        field: "id",
        width: 130,
        minWidth: 130,
        maxWidth: 130,
        pinned: "right",
        cellClass: "my-right-aligned-cell",
        suppressMenu: true,
        suppressSorting: true,
        suppressResize: true,
        suppressSizeToFit: true,
        cellRenderer: function (params) {
          if (params.data == undefined || params.data.id == undefined) return;
          var toReturn = [];
          var eDiv = document.createElement("div");
          eDiv.style.cssText =
            "display:flex;justify-content:flex-end;align-items:center;gap:6px;width:100%;";
          toReturn.push(
            '<a href ng-click="ctrl.openAssociatedForms(\'' +
              params.data.id +
              '\')" class="teams--copy" uib-tooltip="' +
              $translate.instant("DASHBOARD.DASH_INTEG.ASSOCIATED_FORMS") +
              '" tooltip-placement="bottom-right" tooltip-append-to-body="true"><i class="icon ion-code-download"></i></a>'
          );
          toReturn.push(
            '<a href ui-sref="dashboard.integrations.integration({integrationId: \'' +
              params.data.id +
              "', copy: true })\" class=\"teams--copy\" uib-tooltip=\"" + 
              $translate.instant("DASHBOARD.COPY") + 
              "\" tooltip-placement=\"bottom-right\" tooltip-append-to-body=\"true\"><i class=\"icon ion-document\"></i></a>"
          );
          if (!params.data.readOnly) {
            toReturn.push(
              '<a href ng-click="ctrl.removeIntegrationById(\'' +
                params.data.id +
                '\')" class="teams--delete" uib-tooltip="' +
                $translate.instant("DASHBOARD.DELETE") +
                '" tooltip-placement="bottom-right" tooltip-append-to-body="true"><i class="icon ion-android-delete"></i></a>'
            );
          }
          eDiv.innerHTML = toReturn.join("");
          return eDiv;
        },
      },
    ];

    _this.gridOptions = {
      rowData: _this.integrations,
      rowHeight: 50,
      columnDefs: _this.columnDefs,
      pagination: false,
      enableFilter: true,
      enableSorting: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileFilters: true,
      angularCompileHeaders: true,
      headerHeight: 40,
      localeText: gridConfiguration.localeText,
      getRowStyle: function (params) {
        if (params.data && params.data.readOnly) {
          return { backgroundColor: "#f5f5f5" };
        }
        return null;
      },
      onRowDoubleClicked: function (row) {
        $state.go("dashboard.integrations.integration", {
          integrationId: row.data.id,
        });
      },
      onGridReady: function () {
        var host = document.getElementById("dashboard-integrations-grid-host");
        if (host) {
          gridConfiguration.bindShiftWheelHorizontalScroll(host);
          gridConfiguration.bindPinnedRightScrollbarSync(host, _this.gridOptions.api);
        }
      },
    };

    this.openAssociatedForms = (integrationId) => {
      associatedFormsModal.open(integrationId, departments);
    };

    this.removeIntegrationById = function (integrationId) {
      var integration = _this.integrations.find(function (currentIntegration) {
        return currentIntegration.id === integrationId;
      });
      if (integration) {
        _this.removeIntegration(integration);
      }
    };

    const escapeHtml = (value) => {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    };

    this.removeIntegration = (integration) => {
      if (_this.checkingDeleteId) {
        return;
      }
      _this.checkingDeleteId = integration.id;

      associatedFormsModal
        .confirmInUse(integration, departments)
        .then(function () {
          return dialog.confirm({
            title: $translate.instant("DASHBOARD.DASH_INTEG.DIAG_DEL.TITLE"),
            body: $sce.trustAsHtml(
              $translate.instant("DASHBOARD.DASH_INTEG.DIAG_DEL.BODY", {
                name: escapeHtml(integration.name),
              })
            ),
            accept: $translate.instant("DASHBOARD.DELETE"),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: "md",
            html: true,
          });
        })
        .then(function () {
          return Integration.removeById({
            id: integration.id,
          }).$promise;
        })
        .then(function () {
          _this.integrations = _this.integrations.filter(function (
            currentIntegration
          ) {
            return integration.id !== currentIntegration.id;
          });
          if (_this.gridOptions.api) {
            _this.gridOptions.api.setRowData(_this.integrations);
          }
        })
        .catch(function (error) {
          if (error && error.associatedForms) {
            toast.error(
              $translate.instant("DASHBOARD.DASH_INTEG.ASSOCIATED_FORMS_ERROR")
            );
            return;
          }
          if (error && error.status) {
            console.log(error);
          }
        })
        .finally(function () {
          _this.checkingDeleteId = null;
        });
    };

    this.importIntegration = function () {
        $uibModal
        .open({
            animation: true,
            templateUrl: "dashboard-integrations/importIntegrationDialog.html",
            controller: [
                "$scope",
                "$uibModalInstance",
                function (
                    $scope,
                    $uibModalInstance,
                ) {
                    var _this = this;
                    $scope.fileContent = undefined;
                    _this.fileContent = undefined;
                    _this.integName = "";

                    _this.clearFileInput = function (error) {
                        // If it is the first time the file is loaded
                        if ($scope.fileContent === undefined && !error) {
                            _this.openNewFile();
                        // If a file was uploaded, the uploaded data will be lost.
                        } else {
                            if (error) {
                                $scope.fileContent = undefined;
                                _this.fileContent = undefined;
                                _this.integName = "";

                                dialog.confirm({
                                    title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
                                    body: $translate.instant("DASHBOARD.DASH_INTEG.DIAG_IMPORT.FILE_VALID"),
                                    accept: $translate.instant("DASHBOARD.ACCEPT"),
                                    cancel: $translate.instant("DASHBOARD.CANCEL"),
                                    size: "md",
                                })
                                .then(function () {
                                    
                                    _this.openNewFile();
                                });

                            } else {
                                dialog.confirm({
                                    title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
                                    body: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.DIALOG_CONFIRM.BODY"),
                                    accept: $translate.instant("DASHBOARD.ACCEPT"),
                                    cancel: $translate.instant("DASHBOARD.CANCEL"),
                                    size: "md",
                                })
                                .then(function () {
                                    $scope.fileContent = undefined;
                                    _this.fileContent = undefined;
                                    _this.integName = "";
                                    _this.openNewFile();
                                });
                            }
                        }
                    };
                
                    _this.openNewFile = function () {
                        // Create file input, open the file selection window, asign value to fileContent.
                        var input = document.createElement('input');
                        input.type = 'file';
                        input.accept = '.json'; // Only .json files
                        input.style.display = 'none';
                        document.body.appendChild(input);
                
                        input.addEventListener('change', function () {
                            var file = input.files[0];
                            var reader = new FileReader();
                            reader.onload = function (event) {
                                try {
                                    // Parse JSON content
                                    var fileContent = JSON.parse(event.target.result);

                                    // Basic json fields required for integration
                                    if (!fileContent?.name || !fileContent?.configuration || !fileContent?.type) {
                                        // console.log('File content no tiene alguno de los campos', fileContent)
                                        throw new Error('Required field are missing or empty');
                                    }

                                    $scope.$applyAsync(function () {
                                        $scope.fileContent = fileContent;
                                        _this.fileContent = fileContent;
                                        _this.integName = fileContent.name;
                                    });
                                    // console.log('$scope.fileContent', $scope.fileContent);
                                    // console.log('_this.fileContent', _this.fileContent);
                                } catch (error) {
                                    _this.clearFileInput(true);
                                    // console.error('Error parsing JSON:', error);
                                    toast.error($translate.instant("DASHBOARD.DASH_INTEG.DIAG_IMPORT.FILE_VALID"));
                                }
                            };
                            reader.readAsText(file);
                            document.body.removeChild(input);
                        });
                    
                        input.click();
                    }

                    this.close = () => {
                        let integration = undefined;

                        if (_this.fileContent) {
                            if (_this.integName && _this.integName.trim() !== '') {
                                integration = JSON.parse(JSON.stringify(_this.fileContent));
                                integration.name = _this.integName;
    
                                _this.loading = true;
                                
                                // SAVE INTEGRATION
                                delete integration.id;
                                delete integration.tenantId;
                                delete integration.clientId;
                                delete integration.departmentId;
                                sanitizeMongoKeys.prepareIntegration(integration);
    
                                Integration.create({}, integration)
                                .$promise.then(function (created) {
                                    if (!created || !created.id) {
                                        _this.loading = false;
                                        toast.error($translate.instant("DASHBOARD.DASH_INTEG.DIAG_IMPORT.CREATE_NO_ID"));
                                        return;
                                    }
                                    _this.loading = false;
                                    
                                    $uibModalInstance.close({});

                                    return $state
                                        .go("dashboard.integrations", {}, { reload: true })
                                        .then(function () {
                                            $state.go(
                                                "dashboard.integrations.integration",
                                                {
                                                    integrationId: created.id,
                                                }
                                            );
                                        }
                                    );
                                })
                                .catch(function (error) {
                                    _this.loading = false;
                                    console.log(error);
                                    const apiMessage = (error && error.data && error.data.error && error.data.error.message)
                                        || (error && error.message)
                                        || "";
                                    toast.error(
                                        apiMessage
                                            ? $translate.instant("DASHBOARD.DASH_INTEG.DIAG_IMPORT.CREATE_FAILED") + ": " + apiMessage
                                            : $translate.instant("DASHBOARD.DASH_INTEG.DIAG_IMPORT.CREATE_FAILED")
                                    );
                                });
                            } else {
                                toast.error(
                                    $translate.instant(
                                        "DASHBOARD.DASH_INTEG.DIAG_IMPORT.NO_NAME_INTEG"
                                    )
                                    // "Debe ingresar un nombre para la integración."
                                );
                            }
                        } else {
                            toast.error(
                                $translate.instant(
                                    "DASHBOARD.DASH_INTEG.DIAG_IMPORT.FILE_VALID_2"
                                )
                                // "Seleccione un archivo válido."
                            );
                        }
                    }
                },
            ],
            resolve: {
            },
            controllerAs: "ctrl",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
        })
        .result.then(
            function (params) {
            }
        );
    };
  },
];
